import { useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import moment from 'moment/moment'

import Container from 'src/ui/molecules/Container'
import Button from 'src/ui/atoms/Button'
import Table from 'src/ui/organisms/Table'

import useApiKeysApi from './useApiKeysApi'

const APIKeys = () => {
  const navigate = useNavigate()
  const [APITokensList, setAPITokensList] = useState<[]>([])
  const { getTokens, revokeToken } = useApiKeysApi()

  const handleGetAPITokens = async () => {
    const res = await getTokens()

    if (res) {
      setAPITokensList(res)
    }
  }

  const revokeApiToken = async (id: number) => {
    await revokeToken(id)

    handleGetAPITokens()
  }

  useEffect(() => {
    handleGetAPITokens()
  }, [])

  const isAnyTokenActive = APITokensList.length && APITokensList.some((key: any) => key.isActive)
  const activeTokens = APITokensList.filter(({ isActive }) => isActive)

  const columns = [
    {
      key: 'name',
      name: 'Name',
      render: (data: any) => data.name,
    },
    {
      key: 'redactedKey',
      name: 'Token',
      width: '40%',
      render: (data: any) => data.redactedKey,
    },
    {
      key: 'createdAt',
      name: 'Created At',
      render: (data: any) => moment(data.createdAt).format('DD MMM YYYY'),
    },
    {
      key: 'actions',
      name: 'Actions',
      render: (data: any) => (
        <span
          className="icon-close cursor-pointer text-lg text-red"
          onClick={() => revokeApiToken(data.id)}></span>
      ),
    },
  ]

  return (
    <Container
      title="API Tokens"
      empty={!isAnyTokenActive ? "You don't have any API keys" : ''}
      action={
        <Button size="M" name="Generate API token" onClick={() => navigate('/api-generate')} />
      }>
      {isAnyTokenActive ? (
        <Table
          columns={columns}
          itemsPerPage={10}
          fetchData={(page: number) => {
            const indexOfLastItem = page * 10
            const indexOfFirstItem = indexOfLastItem - 10
            return {
              data: activeTokens.slice(indexOfFirstItem, indexOfLastItem),
              totalCount: activeTokens.length,
            }
          }}
        />
      ) : (
        ''
      )}
    </Container>
  )
}

export default APIKeys
